import { Component, computed, input } from '@angular/core';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { DefaultComponentModule } from '@innogy/core/modules/components';

@Component({
  selector: 'wl-commodity-offer-label',
  templateUrl: './commodity-offer-label.component.html',
  styleUrls: [
    './commodity-offer-label.component.ed.scss',
    './commodity-offer-label.component.essent.scss',
  ],
  standalone: true,
  imports: [CSCaptureDirective, DefaultComponentModule],
})
export class CommodityOfferLabelComponent {
  readonly style = input.required<
    'highlight' | 'incentive' | 'text' | 'promocode'
  >();
  readonly label = input.required<string>();

  readonly styleClasses = computed(() => `label--${this.style()}`);
}
